
import { Link} from "react-router-dom";
import { PATHS } from '../../paths';

function LogoutPage() {
  return (<div>
    Bye, <Link to={PATHS.LOGIN}>Login</Link> again soon.
  </div>);
}

export { LogoutPage };
